import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';

// Containers
import FormInput from '../../../containers/shared/forms/form-input';
import FormSelect from '../../../containers/shared/forms/form-select';
import { useFetchRegionsAndCountries } from '../hooks';

export const SetupFormFields = () => {
  const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries();
  return (
    <Fragment>
      <fieldset>
        <label htmlFor='country'>{t('client.labels.country')}</label>
        <FormSelect fieldName='country' fieldValues={formattedCountries} />
      </fieldset>
      <fieldset>
        <label htmlFor='companyName'>{t('client.placeholders.company-name')}</label>
        <FormInput fieldName='companyName' />
      </fieldset>
      <fieldset>
        <label htmlFor='street1'>{t('client.labels.primary-business-address-1')}</label>
        <FormInput fieldName='street1' maxLength={50} />
      </fieldset>
      <fieldset>
        <label htmlFor='street2'>{t('client.labels.optional')}</label>
        <FormInput fieldName='street2' maxLength={50} />
      </fieldset>
      <fieldset>
        <label htmlFor='city'>{t('client.labels.city')}</label>
        <FormInput fieldName='city' addPadding={true} />
      </fieldset>
      <fieldset>
        <label htmlFor='state'>{t('client.labels.region')}</label>
        <FormSelect fieldName='state' fieldValues={formattedRegions} />
      </fieldset>
      <fieldset>
        <label htmlFor='postalCode'>{t('client.labels.postal-code')}</label>
        <FormInput fieldName='postalCode' addPadding={true} />
      </fieldset>
    </Fragment>
  );
};
